import { Node as ProseNode } from 'prosemirror-model'
import { NodeWithPos } from 'prosemirror-utils'

export const findNodeByBlockId = (parentNode: ProseNode, blockId: string): NodeWithPos | null => {
  let foundNode: NodeWithPos | null = null
  parentNode.descendants((node, pos) => {
    if (node.attrs.blockId === blockId) {
      foundNode = { node, pos }
      return false
    }
  })
  return foundNode
}
